module.exports = __webpack_public_path__ + "img/yello_flag.9b32751b.svg";